// Calcula y muestra la fecha estimada de envío en el carrito, a partir de los metafields
// custom.tiempo_de_preparaci_ / custom.tiempo_preparacion_no_stock (texto libre, ej. "8 a 20 días hábiles").
// Reemplazo de la app "Arrive By". Misma lógica (copiada a mano) en la extensión de checkout —
// si cambias la regla aquí, cámbiala también ahí.
(function () {
  if (window.__tiempoEnvioCargado) return; // se carga global en theme.liquid; evita doble registro
  window.__tiempoEnvioCargado = true;

  var DIAS_SEMANA = ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"];
  var MESES = ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"];

  // Festivos de Colombia (fecha OBSERVADA, ya con la Ley Emiliani que mueve varios al lunes).
  // Actualizar cada año. IMPORTANTE: mantener esta misma lista en server.js del bot.
  var FESTIVOS_CO = {
    "2026-01-01":1,"2026-01-12":1,"2026-03-23":1,"2026-04-02":1,"2026-04-03":1,"2026-05-01":1,
    "2026-05-18":1,"2026-06-08":1,"2026-06-15":1,"2026-06-29":1,"2026-07-13":1,"2026-07-20":1,
    "2026-08-07":1,"2026-08-17":1,"2026-10-12":1,"2026-11-02":1,"2026-11-16":1,"2026-12-08":1,"2026-12-25":1,
    "2027-01-01":1,"2027-01-11":1,"2027-03-22":1,"2027-03-25":1,"2027-03-26":1,"2027-05-01":1,
    "2027-05-10":1,"2027-05-31":1,"2027-06-07":1,"2027-07-05":1,"2027-07-20":1,"2027-08-07":1,
    "2027-08-16":1,"2027-10-18":1,"2027-11-01":1,"2027-11-15":1,"2027-12-08":1,"2027-12-25":1
  };
  function isoLocal(f) {
    var m = ("0" + (f.getMonth() + 1)).slice(-2), d = ("0" + f.getDate()).slice(-2);
    return f.getFullYear() + "-" + m + "-" + d;
  }
  function esHabil(f) {
    var w = f.getDay();
    return w !== 0 && w !== 6 && !FESTIVOS_CO[isoLocal(f)]; // ni fin de semana ni festivo
  }

  function extraerDias(texto) {
    var nums = (texto.match(/\d+/g) || []).map(Number);
    if (!nums.length) return null;
    return { min: Math.min.apply(null, nums), max: Math.max.apply(null, nums) };
  }

  // Antes de las 12pm: hoy cuenta como un día de avance (un día menos por sumar).
  // Después de las 12pm: hoy ya no cuenta (un día más).
  function ajustarPorCorteMediodia(dias, ahora) {
    var ajuste = ahora.getHours() < 12 ? -1 : 1;
    return Math.max(0, dias + ajuste);
  }

  function sumarDiasHabiles(desde, dias) {
    var fecha = new Date(desde);
    var agregados = 0;
    if (dias <= 0) return fecha;
    while (agregados < dias) {
      fecha.setDate(fecha.getDate() + 1);
      if (esHabil(fecha)) agregados++; // salta fines de semana y festivos de Colombia
    }
    return fecha;
  }

  function formatear(fecha) {
    return DIAS_SEMANA[fecha.getDay()] + " " + fecha.getDate() + " de " + MESES[fecha.getMonth()];
  }

  function calcularRango(texto, ahora) {
    var dias = extraerDias(texto);
    if (!dias) return null;
    var minAjustado = ajustarPorCorteMediodia(dias.min, ahora);
    var maxAjustado = ajustarPorCorteMediodia(dias.max, ahora);
    var fechaMin = sumarDiasHabiles(ahora, minAjustado);
    var fechaMax = sumarDiasHabiles(ahora, maxAjustado);
    return { fechaMin: fechaMin, fechaMax: fechaMax };
  }

  // Texto plano "vie, 26 de jun. - mar, 30 de jun." — mismo formato que usaba Arrive By,
  // para que el bot de WhatsApp (server.js, busca la clave que contiene "enviar") siga funcionando igual.
  function textoPropiedad(texto, ahora) {
    var rango = calcularRango(texto, ahora);
    if (!rango) return null;
    var fmin = formatear(rango.fechaMin);
    if (rango.fechaMin.getTime() === rango.fechaMax.getTime()) return fmin + ".";
    return fmin + " y el " + formatear(rango.fechaMax) + ".";
  }

  // Fecha estimada de LLEGADA para la ficha: preparación (texto del metacampo) más los días
  // hábiles de tránsito de /pages/envios. No cambia la regla de despacho de arriba ni la de
  // la extensión de checkout. 2026-09-28.
  window.lcmTextoLlegada = function (textoPrep, transitoMin, transitoMax) {
    var dias = extraerDias(textoPrep || "");
    if (!dias) return null;
    var ahora = new Date();
    var fMin = sumarDiasHabiles(ahora, ajustarPorCorteMediodia(dias.min, ahora) + transitoMin);
    var fMax = sumarDiasHabiles(ahora, ajustarPorCorteMediodia(dias.max, ahora) + transitoMax);
    var desde = fMin.getMonth() === fMax.getMonth()
      ? DIAS_SEMANA[fMin.getDay()] + " " + fMin.getDate()
      : formatear(fMin);
    return { desde: desde, hasta: formatear(fMax) };
  };

  function pintar(el) {
    if (el.dataset.tiempoEnvioListo === "1") return; // ya pintado, no repetir
    var conStock = el.getAttribute("data-disponible") === "true";
    var texto = conStock
      ? el.getAttribute("data-tiempo-stock")
      : el.getAttribute("data-tiempo-no-stock") || el.getAttribute("data-tiempo-stock");
    if (!texto) return;
    var rango = calcularRango(texto, new Date());
    if (!rango) return;
    var fmin = "<strong>" + formatear(rango.fechaMin) + "</strong>";
    var fmax = "<strong>" + formatear(rango.fechaMax) + "</strong>";
    var html;
    if (rango.fechaMin.getTime() === rango.fechaMax.getTime()) {
      html = "Se enviará el " + fmin + ".";
    } else {
      html = "Se enviará entre el " + fmin + " y el " + fmax + ".";
    }
    el.innerHTML = html;
    el.style.fontSize = "0.85em";
    el.hidden = false;
    el.dataset.tiempoEnvioListo = "1";
  }

  function pintarTodos() {
    document.querySelectorAll(".product-cart-item-shipping").forEach(pintar);
  }

  // El tema reemplaza el HTML del carrito por AJAX (sin recargar la página) al agregar,
  // cambiar cantidades, o abrir el drawer — hay que repintar en cada uno de esos momentos.
  document.addEventListener("DOMContentLoaded", pintarTodos);
  document.addEventListener("cart:item-added", pintarTodos);
  document.addEventListener("cart-drawer:open", pintarTodos);
  document.addEventListener("cart:refresh", pintarTodos);
  document.addEventListener("line-item:change:end", pintarTodos);

  // Al agregar al carrito: escribe la propiedad de línea ANTES de que el formulario se envíe,
  // para que quede guardada en el pedido para siempre (igual que hacía Arrive By) y tu bot
  // de WhatsApp pueda seguir leyéndola.
  function llenarPropiedadAntesDeAgregar(boton) {
    var input = boton.form ? boton.form.querySelector(".tiempo-envio-prop") : null;
    if (!input) return;
    var conStock = true;
    var variantesEl = boton.form.querySelector(".tiempo-envio-variantes");
    var variantIdInput = boton.form.querySelector('input[name="id"]');
    if (variantesEl && variantIdInput) {
      try {
        var mapa = JSON.parse(variantesEl.textContent);
        var qty = mapa[variantIdInput.value];
        if (typeof qty === "number") conStock = qty > 0;
      } catch (e) {}
    }
    var texto = conStock
      ? input.getAttribute("data-tiempo-stock")
      : input.getAttribute("data-tiempo-no-stock") || input.getAttribute("data-tiempo-stock");
    if (!texto) return;
    var valor = textoPropiedad(texto, new Date());
    if (valor) input.value = valor;
  }

  // Nota: cubre el formulario de la página de producto (el flujo principal de compra).
  // El botón de "agregar rápido" en tarjetas de colección usa otro mecanismo (construye su
  // propio request sin leer el formulario) y no queda cubierto por esto todavía.
  document.addEventListener(
    "click",
    function (event) {
      var boton = event.target.closest(".single-add-to-cart-button");
      if (boton && boton.form) llenarPropiedadAntesDeAgregar(boton);
    },
    true // capture: corre antes de que el handler de submit del tema dispare el fetch
  );
})();
